"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtractionTypeEnum = exports.DocumentUploadStageEnum = exports.DocumentRuleTypeEnum = exports.DocumentRuleSeverityEnum = exports.DigitalFolderSource = exports.DigitalSource = exports.UploadedDocumentSource = exports.DocumentStageEnum = void 0;
var DocumentStageEnum;
(function (DocumentStageEnum) {
    DocumentStageEnum["DELETED"] = "Deleted";
    DocumentStageEnum["DONE"] = "Done";
    DocumentStageEnum["FINISHED"] = "Finished";
    DocumentStageEnum["INGESTION_COMPLETED"] = "IngestionCompleted";
    DocumentStageEnum["MANUAL_PROCESSING_STARTED"] = "ManualProcessingStarted";
    DocumentStageEnum["MANUAL_PROCESSING_TO_BE_DELETED"] = "ManualProcessingToBeDeleted";
    DocumentStageEnum["NATIF_PROCESSED"] = "NatifProcessed";
    DocumentStageEnum["NATIF_UPLOADED"] = "NatifUploaded";
    DocumentStageEnum["OPEN"] = "Open";
    DocumentStageEnum["PENDING_TRANSFER"] = "PendingTransfer";
    DocumentStageEnum["PRE_PROCESSING"] = "PreProcessing";
    DocumentStageEnum["PROCESSING"] = "Processing";
    DocumentStageEnum["REJECTED"] = "Rejected";
    DocumentStageEnum["REJECTED_FOR_RE_SCAN"] = "RejectedForReScan";
    DocumentStageEnum["STARTED"] = "Started";
    DocumentStageEnum["TRANSFERRED"] = "Transferred";
    DocumentStageEnum["VALIDATED"] = "Validated";
})(DocumentStageEnum || (exports.DocumentStageEnum = DocumentStageEnum = {}));
var UploadedDocumentSource;
(function (UploadedDocumentSource) {
    UploadedDocumentSource["CUSTOMER_UPLOAD"] = "CUSTOMER_UPLOAD";
    UploadedDocumentSource["DOCUMENT_SPLIT_UPLOAD"] = "DOCUMENT_SPLIT_UPLOAD";
    UploadedDocumentSource["EMAIL_UPLOAD"] = "EMAIL_UPLOAD";
    UploadedDocumentSource["SCAN_UPLOAD"] = "SCAN_UPLOAD";
})(UploadedDocumentSource || (exports.UploadedDocumentSource = UploadedDocumentSource = {}));
var DigitalSource;
(function (DigitalSource) {
    DigitalSource["COPY"] = "COPY";
    DigitalSource["CUSTOMER_UPLOAD"] = "CUSTOMER_UPLOAD";
    DigitalSource["DOCUMENT_SPLIT_UPLOAD"] = "DOCUMENT_SPLIT_UPLOAD";
    DigitalSource["EMAIL_UPLOAD"] = "EMAIL_UPLOAD";
    DigitalSource["SHARED_DOCUMENT"] = "SHARED_DOCUMENT";
    DigitalSource["WELCOME_DOCUMENT"] = "WELCOME_DOCUMENT";
    DigitalSource["WELCOME_DOCUMENT_V2"] = "WELCOME_DOCUMENT_V2";
})(DigitalSource || (exports.DigitalSource = DigitalSource = {}));
var DigitalFolderSource;
(function (DigitalFolderSource) {
    DigitalFolderSource["OWNED_FOLDER"] = "OWNED_FOLDER";
    DigitalFolderSource["SHARED_FOLDER"] = "SHARED_FOLDER";
})(DigitalFolderSource || (exports.DigitalFolderSource = DigitalFolderSource = {}));
var DocumentRuleSeverityEnum;
(function (DocumentRuleSeverityEnum) {
    DocumentRuleSeverityEnum["ERROR"] = "Error";
    DocumentRuleSeverityEnum["INFO"] = "Info";
    DocumentRuleSeverityEnum["WARNING"] = "Warning";
})(DocumentRuleSeverityEnum || (exports.DocumentRuleSeverityEnum = DocumentRuleSeverityEnum = {}));
var DocumentRuleTypeEnum;
(function (DocumentRuleTypeEnum) {
    DocumentRuleTypeEnum["AUTOMATIC_PROCESS"] = "AutomaticProcess";
    DocumentRuleTypeEnum["CUSTOMER_NAMES_DONT_MATCH_PUBLIC_ID"] = "CustomerNamesDontMatchPublicId";
    DocumentRuleTypeEnum["CUSTOMER_NAMES_NONE"] = "CustomerNamesNone";
    DocumentRuleTypeEnum["CUSTOMER_NAMES_NOT_FOUND"] = "CustomerNamesNotFound";
    DocumentRuleTypeEnum["DATABREACH_WARNING"] = "DatabreachWarning";
    DocumentRuleTypeEnum["PUBLIC_ID_DOESNT_EXIST"] = "PublicIdDoesntExist";
    DocumentRuleTypeEnum["PUBLIC_ID_FUZZY"] = "PublicIdFuzzy";
    DocumentRuleTypeEnum["PUBLIC_ID_INCORRECT"] = "PublicIdIncorrect";
    DocumentRuleTypeEnum["PUBLIC_ID_INVALID"] = "PublicIdInvalid";
    DocumentRuleTypeEnum["PUBLIC_ID_MORE_THAN_ONE"] = "PublicIdMoreThanOne";
    DocumentRuleTypeEnum["PUBLIC_ID_NONE"] = "PublicIdNone";
    DocumentRuleTypeEnum["PUBLIC_IDS_DONT_MATCH"] = "PublicIdsDontMatch";
})(DocumentRuleTypeEnum || (exports.DocumentRuleTypeEnum = DocumentRuleTypeEnum = {}));
var DocumentUploadStageEnum;
(function (DocumentUploadStageEnum) {
    DocumentUploadStageEnum["COMPLETED"] = "Completed";
    DocumentUploadStageEnum["DISMISSED"] = "Dismissed";
    DocumentUploadStageEnum["FAILED_PROCESSING"] = "FailedProcessing";
    DocumentUploadStageEnum["PENDING"] = "Pending";
    DocumentUploadStageEnum["PROCESSING"] = "Processing";
})(DocumentUploadStageEnum || (exports.DocumentUploadStageEnum = DocumentUploadStageEnum = {}));
var ExtractionTypeEnum;
(function (ExtractionTypeEnum) {
    ExtractionTypeEnum["E_INVOICE"] = "EInvoice";
})(ExtractionTypeEnum || (exports.ExtractionTypeEnum = ExtractionTypeEnum = {}));
//# sourceMappingURL=document-capture.js.map